/**
 * Created by Ning Jiang on 9/22/2016.
 */
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite, TweenLite, Expo, Linear} from "gsap";
import {OktoberfestSymbol} from "../symbol/OktoberfestSymbol";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {Oktoberfest} from "../Oktoberfest";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {OktoberfestSound} from "../sound/OktoberfestSound";

export class OktoberfestCollectionWPView extends PIXI.Container {
    private _addFreespinsText: PIXI.Text;
    private _addFreespinsTextYPos: number;
    private _addFreespinsTimeLine: TimelineLite;
    private _addFreespinsTextStyle: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: (127 * (1280 / 1920)) + "px",
        fill: "#FFFFFF",
        stroke: "#5C521F",
        strokeThickness: 2,
        dropShadow: true,
        dropShadowColor: "#3B3412",
        dropShadowAngle: 0.872665, //PhotoShop 120 real 50
        dropShadowDistance: 5,
        padding: 20
    };

    constructor() {
        super();
        this.initAnimations();
        this._addFreespinsTextYPos = this._addFreespinsText.position.y;
    }

    public playAddFreespinsText(freeSpinsWon: number): void {
        this.updateText(freeSpinsWon);
        const scale: number = NolimitApplication.screenBounds.scale;
        this._addFreespinsText.position.y = this._addFreespinsTextYPos;
        this._addFreespinsTimeLine = new TimelineLite({paused: true});
        this._addFreespinsTimeLine.add([
            () => {
                OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_FS_MORE_SPINS})
            },
            new TweenLite(this._addFreespinsText, 0.2, {alpha: 1,}),
            new TweenLite(this._addFreespinsText.scale, 0.5, {x: (1 * scale), y: (1 * scale), ease: Expo.easeOut}),
            new TweenLite(this._addFreespinsText.position, 3.5, {y: "-=80", ease: Linear.easeNone})
        ]);
        this._addFreespinsTimeLine.add([
            new TweenLite(this._addFreespinsText, 0.5, {alpha: 0, ease: Expo.easeOut})
        ], "-=1.5");
        this._addFreespinsTimeLine.add([
            new TweenLite(this._addFreespinsText.scale, 0.01, {x: 0, y: 0}),
            new TweenLite(this._addFreespinsText.position, 0.01, {y: (NolimitApplication.screenBounds.height / 2) * 0.5})
        ]);

        this._addFreespinsTimeLine.timeScale(Oktoberfest.apiPlugin.settings.get(APISetting.FAST_SPIN) ? 2 : 1);
        this._addFreespinsTimeLine.play(0);
    }

    protected initAnimations(): void {
        let winFieldLayer: PIXI.Container = OktoberfestLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
        this._addFreespinsText = new PIXI.Text("+3 bier spins", this._addFreespinsTextStyle);
        this._addFreespinsText.anchor.set(0.5, 0.5);
        this._addFreespinsText.alpha = 0;
        this._addFreespinsText.position.set(360);
        winFieldLayer.addChild(this._addFreespinsText);
        this.position.set(360, 360);
    }

    private updateText(freespinsWon: number): void {
        this._addFreespinsText.text = "+ " + freespinsWon + " bier spins";
    }
}
